import React, { useState, useEffect } from "react";
import { getIcon } from "../../../utils/icons";
import { useDispatch, useSelector } from 'react-redux'; 
import "./ToolGrounding.css";
import { setCommandType, resetOperation, setCommandMessage } from "../../../redux/operationSlice";
import { COMMANDS } from "../../../utils/commonProperties";

const ToolGrounding = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const buttonSize = 30;
  const dispatch = useDispatch();
  const commandType = useSelector((state) => state.operation.commandType);

  // TIKLANDIĞINDA
  const handleClick = (tool) => { 
    const command = COMMANDS[`DRAW_${tool.toUpperCase()}`];
    if (commandType === command) {
      dispatch(resetOperation());
    } else {
      dispatch(setCommandType(command));
      dispatch(setCommandMessage("İlk noktayı seçin"));
    }
  };

  // Redux commandType değiştiğinde activeButton'ı güncelle
  useEffect(() => { 

    if (commandType === COMMANDS.DRAW_GROUNDINGSTRIP) {
      setActiveButton("groundingStrip");
    } else if (commandType === COMMANDS.DRAW_GROUNDINGSTAKE) {
      setActiveButton("groundingStake");
    } else {
      setActiveButton(null);
    }
  }, [commandType]);

  const toolLabelMap = {
    groundingStrip: "Topraklama Şeridi",
    groundingStake: "Topraklama Çubuğu",
  };

  return (
    <div className={`toolGrounding ${isOpen ? "open" : "closed"}`}>
      {isOpen && (
        <div className="toolGrounding-left">
          <div className="toolGroundingRow">
            {["groundingStrip", "groundingStake"].map((tool) => (
              <button
                key={tool}
                title={toolLabelMap[tool]}
                className={`toolGroundingButton ${activeButton === tool ? "active" : ""}`}
                style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
                onClick={() => handleClick(tool)}
              >
                {getIcon(tool, buttonSize)}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="toolGrounding-toggle">
        <button
          className="toolGroundingButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? "◀" : "Topraklama▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolGrounding;
